export const Default = {
    computed: {
        callback: {
            get: function() {
                return this.$store.getters[this.$store.types.path.getters.get].callback;
            },
            set: async function(newCallback) {
                await this.$store.dispatch(this.$store.types.path.actions.set, {callback: newCallback});
            }
        },
        lastPath: {
            get: function() {
                return this.$store.getters[this.$store.types.path.getters.get].lastPath;
            }
        },
        setup: {
            get: function() {
                return this.$store.getters[this.$store.types.path.getters.get].setup;
            },
            set: async function(newSetup) {
                await this.$store.dispatch(this.$store.types.path.actions.set, {setup: newSetup});
            }
        },
        queryErrors: {
            get: function() {
                return this.$store.getters[this.$store.types.path.getters.get].queryErrors;
            },
            set: async function(newQueryError) {
                await this.$store.dispatch(this.$store.types.path.actions.addQueryError, newQueryError);
            }
        },
        userRights: {
            get: function() {
                return this.$store.getters[this.$store.types.user.getters.get].rights;
            }
        },
        userIsSuperUser: {
            get: function() {
                return this.$store.getters[this.$store.types.user.getters.get].superUser;
            }
        }
    },
    methods: {
        requiresRight: function(rightId) {
            if (this.userIsSuperUser)
                return true;
            return this.userRights.indexOf(this.$parleyAdmin.auth.getRightsById([rightId])[0].id) !== -1;
        }
    },
    created() {
        try {
            this.$validator.errors.clear();
        } catch (e) {}
    }
};
